import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MAX_NAME_LENGTH } from '../../helpers/validations';
import { PencilFilledIcon } from '../../icons';

import styles from './_index.module.scss';

const TitleInput = ({
  autoFocus,
  className,
  error,
  icon,
  isDisabled,
  onBlur,
  onChange,
  placeholder,
  value,
}) => {
  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      onChange(event.target.value);
      event.target.blur();
    }
  };

  return (
    <div
      className={classNames(styles['title-input'], className, {
        [styles['has-error']]: error,
        [styles['is-disabled']]: isDisabled,
      })}
    >
      <div className={styles['title-input-wrapper']}>
        <span aria-hidden className={styles['title-input-icon']}>
          {icon || <PencilFilledIcon />}
        </span>
        <input
          autoFocus={autoFocus}
          className={classNames(styles['title-input-field'], {
            [styles['has-error']]: error,
          })}
          data-testid="title-input"
          disabled={isDisabled}
          maxLength={MAX_NAME_LENGTH}
          onBlur={(event) => onBlur(event.target.value)}
          onChange={(event) => onChange(event.target.value)}
          onFocus={(event) => event.target.select()}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          type="text"
          value={value}
        />
      </div>
      {error && <p className={styles['title-input-error']}>{error}</p>}
    </div>
  );
};

TitleInput.defaultProps = {
  isDisabled: false,
  onBlur: () => {},
  value: '',
};

TitleInput.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.element,
  isDisabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default TitleInput;
